import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase.ts";
import { type User } from "./userModel.ts";

export type SearchType = "exact" | "prefix";

interface Request {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
  searchField?: string;
  searchType?: SearchType;
}

interface Response {
  success: boolean;
  users: User[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

export const swrKey = "admin_getUsers";

export const usersFetcher = async ([
  _key,
  page,
  pageSize,
  searchTerm,
  searchField,
  searchType
]: [
  string,
  number,
  number,
  string | null,
  string | null,
  SearchType | null,
]) => {
  const functions = getFirebaseFunctions();
  const getUsersFunction = httpsCallable<Request, Response, object>(
    functions,
    swrKey,
  );

  const requestData: Request = {
    page,
    pageSize,
  };

  // Add search parameters if they exist
  if (searchTerm && searchField && searchType) {
    requestData.searchTerm = searchTerm;
    requestData.searchField = searchField;
    requestData.searchType = searchType;
  }

  const res = await getUsersFunction(requestData);
  return res.data;
};
